<template>
  <v-text-field
    ref="textField"
    :autocomplete="autocompleteValue"
    :id="id"
    v-model="displayValue"
    :label="mylabel"
    :error="!!error"
    :error-messages="error"
    suffix="€"
    outlined
    filled
    @blur="handleBlur"
  ></v-text-field>
</template>

<script>
import Cleave from "cleave.js";

export default {
  name: "ContactInputCurrency",

  props: ["name", "group", "label"],

  data() {
    return {
      val: null,
      displayValue: "",
      cleave: null,
    };
  },

  computed: {
    invalid() {
      return this.$root.contactForm.errors.indexOf(this.name) > -1;
    },

    autocompleteValue() {
      return undefined;
    },

    required() {
      return this.$root.contactForm.isRequired(this.name);
    },

    error() {
      if (this.invalid) {
        return "Pflichtfeld";
      }
      return null;
    },

    mylabel() {
      if (this.required) {
        return `${this.label}*`;
      }
      return this.label;
    },

    id() {
      return `contact__${this.name}`;
    },
  },

  mounted() {
    this.initializeValue();
    this.$root.contactForm.registerField(this);
    this.$nextTick(this.initializeCleave);
  },

  beforeDestroy() {
    this.destroyCleave();
    this.$root.contactForm.unregisterField(this);
  },

  methods: {
    initializeValue() {
      if (this.group == "contact") {
        this.val = this.$root.contactForm.contact[this.name];
        if (this.val) {
          this.displayValue = this.formatNumber(this.val);
        }
      }
    },

    initializeCleave() {
      const input = this.getInputElement();
      if (input) {
        this.cleave = new Cleave(input, {
          numeral: true,
          numeralThousandsGroupStyle: "thousand",
          numeralDecimalMark: ",",
          delimiter: ".",
          numeralPositiveOnly: true,
          onValueChanged: this.handleValueChanged,
        });
      }
    },

    getInputElement() {
      return this.$refs.textField?.$el?.querySelector("input");
    },

    handleValueChanged(e) {
      this.displayValue = e.target.value;
      const rawValue = this.cleave.getRawValue();
      this.val = rawValue ? parseFloat(rawValue) : null;
    },

    handleBlur() {
      this.mapValue();
    },

    formatNumber(value) {
      if (!value) return "";
      return new Intl.NumberFormat("de-DE").format(value);
    },

    mapValue() {
      if (this.group == "contact") {
        this.$root.contactForm.contact[this.name] = this.val;
      }
    },

    destroyCleave() {
      if (this.cleave) {
        this.cleave.destroy();
      }
    },
  },
};
</script>
